module.exports = __webpack_public_path__ + "static/51-iWedia-7647134e0132e845cab60c3c96f36815.png";